// Any button on the public site can open the single login modal owned by
// SiteHeader, the same way window.alert is routed to AppAlertDialog.
// Pass { redirect } (a router location) to land somewhere other than My Page
// after signing in.
export const OPEN_LOGIN_EVENT = 'open-login';

export function openLogin(options = {}) {
    window.dispatchEvent(new CustomEvent(OPEN_LOGIN_EVENT, { detail: options }));
}
